import type {APIPacket, RequestMessage, ResultError} from '@bpinc/adapters-public-api-types'
import {RESPONSE_SUFFIX} from '@bpinc/adapters-public-api-types'
import type {EventSubscription} from '@bpinc/lib-typed-events'


const TO_ADAPTER_STORAGE_KEY = 'bp-api-communicator-to-adapter'
const FROM_ADAPTER_STORAGE_KEY = 'bp-api-adapter-to-communicator'
const MAGIC_STRING_UNDEFINED = 'p0iu1_k@7p0v14'

export function subscribeToAPIAdapter(listener: (value: string) => void): EventSubscription {
    const storageEventHandler = async (storageEvent: StorageEvent) => {
        if (
            storageEvent.storageArea !== sessionStorage ||
            storageEvent.key !== FROM_ADAPTER_STORAGE_KEY ||
            !storageEvent.newValue
        ) {
            return
        }
        try {
            const objectValue = JSON.parse(
                storageEvent.newValue,
                (_key, value) => value === MAGIC_STRING_UNDEFINED ? undefined : value,
            )
            listener(objectValue)
        } catch {
            return
        }
    }
    window.addEventListener('storage', storageEventHandler)

    return {
        unsubscribe: () => window.removeEventListener('storage', storageEventHandler),
    }
}

export function writeMessageToAPIAdapter(data: APIPacket) {
    const dataJson = JSON.stringify(
        data,
        (_key, value) => value === undefined ? MAGIC_STRING_UNDEFINED : value,
    )
    sessionStorage.setItem(TO_ADAPTER_STORAGE_KEY, dataJson)
    sessionStorage.removeItem(TO_ADAPTER_STORAGE_KEY)
}

export function respondToAPIAdapter(
    instanceId: string,
    uid: string,
    requestMessage: RequestMessage,
    data: unknown,
    coordinatorId?: string,
) {
    writeMessageToAPIAdapter({
        instanceId,
        uid,
        type: `${requestMessage}${RESPONSE_SUFFIX}`,
        params: [{
            status: 'success',
            data,
        }],
        coordinatorId,
    })
}

export function respondErrorToAPIAdapter(
    instanceId: string,
    uid: string,
    eventType: string,
    resultErrorInner: ResultError,
    coordinatorId?: string,
) {
    writeMessageToAPIAdapter({
        instanceId,
        uid,
        type: `${eventType}${RESPONSE_SUFFIX}`,
        params: [{
            status: 'error',
            error: resultErrorInner,
        }],
        coordinatorId,
    })
}
